import { Analytics } from '@cobliteam/analytics';
import Badge from '@cobliteam/colib-ui/Badge';
import Button from '@cobliteam/colib-ui/Button';
import Icon from '@cobliteam/colib-ui/Icon';
import { useTranslation } from '@cobliteam/i18n';
import type { ComponentProps } from 'react';

export interface MultiSelectVehicleGroupsSidebarTriggerProps extends Omit<ComponentProps<typeof Button>, 'size' | 'title'> {
  totalSelectedGroups: number;
  isOpen: boolean;
}

const MultiSelectVehicleGroupSidebarTrigger = ({ totalSelectedGroups, isOpen, ...buttonProps }: MultiSelectVehicleGroupsSidebarTriggerProps) => {
  const { t } = useTranslation('multiselects');

  const onDropdownOpen = () => {
    Analytics.track('Global Filter Opened');
  };

  return (
    <Button
      {...buttonProps}
      aria-label={t('groups.filter_groups')}
      aria-expanded={isOpen}
      variant={isOpen ? 'secondary' : 'outline'}
      className={['shrink-0 max-sm:size-8 max-sm:px-0', buttonProps.className].filter(Boolean).join(' ')}
      size='sm'
      onClick={(event) => {
        buttonProps.onClick?.(event);
        onDropdownOpen();
      }}
    >
      <Icon name='filter' size='sm' />
      <span className='hidden sm:inline'>{t('groups.filter_groups')}</span>
      {totalSelectedGroups > 0 && (
        <Badge variant='secondary' size='sm' className='max-sm:hidden'>
          {totalSelectedGroups}
        </Badge>
      )}
      <Icon name='chevron-down' size='sm' className='max-sm:hidden' />
    </Button>
  );
};

export default MultiSelectVehicleGroupSidebarTrigger;
